/*
Full featured Sample Use:

<input type="text"
       placeholder="Suchbegriff"
       autocomplete="off"
       data-search-target="#addModalTable"
>

<div class="card-body">
    <div class="table-responsive">
        <table class="table" id="addModalTable">
            ...
        </table>
    </div>
</div>
<div class="card-footer"
     data-pagination-target="#addModalTable"
     data-pagination-size="5">
    <div class="d-flex justify-content-between">
        <div class="my-auto">
            <span data-pagination-count></span> Datensätze
        </div>
        <div>
            <ul class="pagination pagination-sm float-right" data-pagination-paging></ul>
        </div>
    </div>
</div>
*/

var filterInputRegistry = {};

// --- Paging ---

function handlePagination(): void {
    const paginations: NodeListOf<HTMLInputElement> = document.querySelectorAll('[data-pagination-target]');

    if (!paginations) {
        return;
    }

    for (let pagination of Array.from(paginations)) {
        attachPagination(pagination);
    }
}

function attachPagination(pagination: HTMLElement): void {
    const paginationTarget = pagination.dataset.paginationTarget;

    if (!paginationTarget) {
        return;
    }

    const tableElement: HTMLElement | null = document.querySelector(paginationTarget);
    const countElement: HTMLElement | null = pagination.querySelector('[data-pagination-count]');
    const pagingElement: HTMLElement | null = pagination.querySelector('[data-pagination-paging]');

    const pageSize = Number(pagination.dataset.paginationSize) || 25;
    const currentPage = Number(pagination.dataset.paginationCurrent) || 1;

    if (!tableElement) {
        return;
    }

    tableElement.dataset.pagination = 'enabled';

    let filterValue: string = '';
    let result: { total: number } = {
        total: 0,
    };

    if (pagingElement) {
        if (paginationTarget in filterInputRegistry) {
            const filterInput = filterInputRegistry[paginationTarget];

            if (tableElement.dataset.filter === 'enabled') {
                filterInput.addEventListener('keyup', () => {
                    filterValue = filterInput.value.toUpperCase();
                    pagination.dataset.paginationCurrent = 1 + '';

                    const result = applyOnTable(tableElement, filterValue, pageSize, 1);
                    renderPaging(pagingElement, pageSize, 1, result.total);

                    if (countElement) {
                        countElement.innerText = result.total + '';
                    }
                });
            }
        }

        result = applyOnTable(tableElement, filterValue, pageSize, currentPage);

        pagingElement.addEventListener('click', (event: Event) => {
            event.preventDefault();

            const target: HTMLElement = event.target as HTMLElement

            let page: number = Number(pagination.dataset.paginationCurrent) || 1;

            switch (target.innerText) {
                case '<':
                    page--;
                    break;
                case '>':
                    page++;
                    break;
                default:
                    page = Number(target.innerText);
            }

            if (isNaN(page)) {
                return;
            }

            page = Math.max(1, Math.min(page, Math.ceil(result.total / pageSize)));

            pagination.dataset.paginationCurrent = page + '';

            result = applyOnTable(tableElement, filterValue, pageSize, page);
            renderPaging(pagingElement, pageSize, page, result.total);

            if (countElement) {
                countElement.innerText = result.total + '';
            }
        });

        renderPaging(pagingElement, pageSize, currentPage, result.total);
    }

    if (countElement) {
        countElement.innerText = result.total + '';
    }
}

function renderPaging(target: HTMLElement, pageSize: number, currentPage: number, items: number): void {
    const pageAmount: number = Math.ceil(items / pageSize);
    const pageElements: NodeListOf<HTMLElement> = target.querySelectorAll('li');

    for (let pageElement of Array.from(pageElements)) {
        pageElement.remove()
    }

    const visiblePages = Math.min(currentPage + 1, pageAmount) - Math.max(1, currentPage - 1);

/*
    Alternative logic
    [<][1]...[3][4][5]...[n][>]

    createPagingElement(target, '<', false, currentPage <= 1);

    if (currentPage > 2) {
        createPagingElement(target, 1, currentPage === 1);
    }

    if (currentPage > 3) {
        createPlaceholderElement(target);
    }

    for (let page = Math.max(1, currentPage - 1); page <= Math.min(currentPage + 1, pageAmount); page++) {
        const pageNumber: number = page;
        const current: boolean = page === currentPage;

        createPagingElement(target, pageNumber, current);
    }

    if (currentPage < pageAmount - 2) {
        createPlaceholderElement(target);
    }

    if (currentPage < pageAmount - 1) {
        createPagingElement(target, pageAmount, currentPage === pageAmount);
    }

    createPagingElement(target, '>', false, currentPage >= pageAmount);
*/

    createPagingElement(target, '<', false, currentPage <= 1);

    const pagesInViewport = 10;

    const overshoot = pagesInViewport / 2;
    const lowerOvershoot = Math.max(1, currentPage - overshoot);
    const upperOvershoot = Math.min(currentPage + overshoot - 1, pageAmount);

    let lowerBoundary =  Math.max(1, parseInt(lowerOvershoot + ''));
    let upperBoundary = Math.min(pageAmount, parseInt(upperOvershoot + ''));

    // 1 .... 5
    if (currentPage - lowerOvershoot < (pagesInViewport - overshoot)) {
        const additionalPages = (pagesInViewport - overshoot + 1) - (currentPage - lowerOvershoot) - 1;

        upperBoundary = Math.min(pageAmount, upperOvershoot + additionalPages);
    }

    // 5 .... n
    if (upperOvershoot - currentPage < (pagesInViewport - overshoot)) {
        const additionalPages = (pagesInViewport - overshoot - 1) - (upperOvershoot - currentPage);

        lowerBoundary = Math.max(1, lowerOvershoot - additionalPages);
    }

    for (let page = lowerBoundary; page <= upperBoundary; page++) {
        const pageNumber: number = page;
        const current: boolean = page === currentPage;


        createPagingElement(target, pageNumber, current);
    }

    createPagingElement(target, '>', false, currentPage >= pageAmount);
}

function createPagingElement(target: HTMLElement, value: string | number, active: boolean = false, disabled: boolean = false): void {
    const pageElement = document.createElement('li');

    pageElement.innerHTML = `
            <li class="page-item${active ? ' active' : ''}${disabled ? ' disabled' : ''}">
                <a class="page-link" href="#">
                    ${value}
                </a>
            </li>
        `;

    target.appendChild(pageElement);
}

function createPlaceholderElement(target: HTMLElement): void {
    const pageElement = document.createElement('li');

    pageElement.innerHTML = `
            <li class="page-item">
                ...
            </li>
        `;

    target.appendChild(pageElement);
}

function applyOnTable(table: HTMLElement, filterValue: string, pageSize: number = 25, currentPage: number = 1): { total: number } {
    const rows: HTMLCollectionOf<HTMLElementTagNameMap['tr']> = table.getElementsByTagName('tr');

    let index: number = 0;
    for (let row of Array.from(rows)) {
        const visible = ((currentPage - 1) * pageSize) <= index && (currentPage * pageSize) > index;
        const cells: HTMLCollectionOf<HTMLElementTagNameMap['td']> = row.getElementsByTagName('td');

        if (cells.length == 0) {
            continue;
        }

        const found: HTMLTableDataCellElement[] = Array.from(cells).filter((cell) => {
            const value = cell.textContent || cell.innerText;

            return value.toUpperCase().indexOf(filterValue) > -1;
        });

        if (found.length === 0) {
            row.style.display = 'none';

            continue;
        }

        if (visible) {
            row.style.display = '';
        } else {
            row.style.display = 'none';
        }

        index++;
    }

    return {
        total: index
    }
}


// --- Filter ---

function handleSearchTargets(): void {
    const filterInputs: NodeListOf<HTMLInputElement> = document.querySelectorAll('[data-search-target]');

    if (!filterInputs) {
        return;
    }

    for (let filterInput of Array.from(filterInputs)) {
        attachFilterInput(filterInput);
    }
}

function attachFilterInput(filterInput: HTMLInputElement): void {
    const filterTarget = filterInput.dataset.searchTarget;

    if (!filterTarget) {
        return;
    }

    filterInputRegistry[filterTarget] = filterInput;

    const tableElement: HTMLElement | null = document.querySelector(filterTarget);

    if (!tableElement) {
        return;
    }

    tableElement.dataset.filter = 'enabled';

    if (tableElement.dataset.pagination === 'enabled') {
        return;
    }

    filterInput.addEventListener('keyup', event => {
        filter(tableElement, filterInput.value.toUpperCase());
    });
}

function filter(table: HTMLElement, filterValue: string): void {
    const rows: HTMLCollectionOf<HTMLElementTagNameMap['tr']> = table.getElementsByTagName('tr');

    for (let row of Array.from(rows)) {
        const cells: HTMLCollectionOf<HTMLElementTagNameMap['td']> = row.getElementsByTagName('td');

        if (cells.length == 0) {
            continue;
        }

        const values: HTMLTableDataCellElement[] = Array.from(cells).filter((cell) => {
            const value = cell.textContent || cell.innerText;

            return value.toUpperCase().indexOf(filterValue) > -1;
        });

        if (values.length > 0) {
            row.style.display = '';
        } else {
            row.style.display = 'none';
        }
    }
}

window.addEventListener('DOMContentLoaded', (event) => {
    handleSearchTargets();
    handlePagination();
}, {once: true});
